// Copyright (c) 2019 Deere & Company

import './index.scss';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import React from 'react';

const FunctionCodePanel = ( {
    productSeries,
    searchKeyFields,
    handleAddClick,
    handleSearchClick,
    handleProductSeriesChange,
    onTextChange,
} ) => (

    <section className="main-panel">
        <section className="input-panel">
            <div className="sub-div">
                <OptionsDropDown
                    className="product-series"
                    label="Product Series"
                    isPlaceholderTranslated={true}
                    onChange={handleProductSeriesChange}
                    optionDisplayAttributes={['label']}
                    optionKey="value"
                    options={productSeries}
                    placeholder=""
                    selectedValue={searchKeyFields.productSeries}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="function-code"
                    name="functionCode"
                    isEditable={true}
                    label="Function Code"
                    maxLength={7}
                    onChange={onTextChange}
                    value={searchKeyFields.functionCode}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="part-number"
                    name="partNumber"
                    isEditable={true}
                    label="Part Number"
                    maxLength={12}
                    onChange={onTextChange}
                    value={searchKeyFields.partNumber}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="manufacturing-module"
                    name="manufacturingModule"
                    isEditable={true}
                    label="Manufacturing Module"
                    maxLength={5}
                    onChange={onTextChange}
                    value={searchKeyFields.manufacturingModule}
                />
            </div>
            <div className="sub-div">
                <LabeledInput
                    className="design-module"
                    name="designTeamCode"
                    isEditable={true}
                    label="Design Module"
                    maxLength={7}
                    onChange={onTextChange}
                    value={searchKeyFields.designTeamCode}
                />
            </div>
            <button
                type="button"
                onClick={handleAddClick}
            >
                <span> Add New </span>
            </button>
            <button
                className="primary-button"
                type="button"
                onClick={handleSearchClick}
                disabled={( ( searchKeyFields.productSeries === 0 || searchKeyFields.productSeries === '-1' )
                         && ( searchKeyFields.functionCode === undefined || ( searchKeyFields.functionCode ).trim() === '' )
                  && ( searchKeyFields.partNumber === undefined || ( searchKeyFields.partNumber ).trim() === '' )
                && ( searchKeyFields.manufacturingModule === undefined || ( searchKeyFields.manufacturingModule ).trim() === '' )
                && ( searchKeyFields.designTeamCode === undefined || ( searchKeyFields.designTeamCode ).trim() === '' )
                )}
            >
                <span> Search </span>
            </button>
        </section>
    </section>


);

FunctionCodePanel.propTypes = {
    productSeries: PropTypes.array.isRequired,
    value: PropTypes.string,
    searchKeyFields: PropTypes.object.isRequired,
    handleAddClick: PropTypes.func.isRequired,
    handleSearchClick: PropTypes.func.isRequired,
    handleProductSeriesChange: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
};

export default FunctionCodePanel;
